import React from "react";

import Icon from "../../icons/red-icon";
import "./style.m.css";

export function RedIconWithText() {
  return (
    <div styleName="image-container">
      <Icon />
      <p styleName="text">One account. All of Prothom Alo working for you</p>
    </div>
  );
}
